import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TCreateInvoicePayoutRequest,
  TCreateInvoicePayoutResponse,
} from "./createInvoicePayout.schema";

export const createInvoicePayout =
  (axios: IAxiosInstance) =>
  async (
    params: TCreateInvoicePayoutRequest
  ): Promise<TCreateInvoicePayoutResponse> => {
    const response = await axios.noRetry.post("/api/invoices/payout", params);
    const resData = response.data;

    if (resData?.success) {
      return resData;
    }

    throw new Error(resData?.error || "Error creating invoice payout");
  };
